import { PublicClientApplication } from "@azure/msal-browser";

const getRedirectUri = () => {
  if (window?.location?.hostname === "localhost") {
    return "http://localhost:3000/";
  }
  return "https://goesgreenapp.com.ar/";
};

const msalConfig = {
  auth: {
    clientId: "796d3e98-be2e-4db8-869c-6280be456e2f",
    authority: "https://login.microsoftonline.com/de659cfd-3b05-4eaf-95c1-45c47b34907a",
    redirectUri: getRedirectUri(),
  },
  cache: {
    cacheLocation: "localStorage",

    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
// Solo para Power BI
export const powerbiScopes = ["https://analysis.windows.net/powerbi/api/.default"];